module.exports = __webpack_public_path__ + "images/emoji/milky_way.cc0e92bb1a2b8ac56866.png";


//////////////////
// WEBPACK FOOTER
// ./resources/images/emoji/milky_way.png
// module id = Sjim
// module chunks = 14